import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { alertInfoTypes } from "shared-components/src/components/feedback/alertInfoTypes.enum";
import { showAlertInfo } from "shared-components/src/components/feedback/store/alertInfo.actions";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import { getApiService } from "../../../services/apiService";
import {
  RESET_PASSWORD_REQUEST,
  resetPasswordSuccess,
} from "../store/resetPassword.actions";

const apiService = getApiService();

const resetPassword = async (data) => {
  const url = `${apiService.getLoginUrl}`;
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await axios.post(url, data, { headers });
  return response.data;
};

function* handleResetPassword(action) {
  try {
    yield put(showProgress());
    const response = yield call(resetPassword, action?.payload);
    yield put(resetPasswordSuccess(response));
    yield put(hideProgress());
  } catch (error) {
    yield put(
      showAlertInfo({
        type: alertInfoTypes.ERROR,
        message: error?.message,
      }),
    );
  }
}

export function* watchResetPassword() {
  yield takeLatest(RESET_PASSWORD_REQUEST, handleResetPassword);
}
